import MDTypography from "components/MDTypography";

import IconButton from "@mui/material/IconButton";
import UploadFile from "@mui/icons-material/UploadFile";
import { Box, TextField, MenuItem, FormControl, Select } from "@mui/material";
export default function variantsTableData(
  attributes,
  combinations,
  onPriceChange,
  onQuantityBlur,
  quantityErrors
) {
  // ✅ تحديد الصور الافتراضية من البيانات المبدئية (عند التعديل)

  // ✅ معالجة رفع الصورة
  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);

      onPriceChange(index, "image", file); // ✅ إرسال الملف كـ File وليس كـ URL
    }
  };

  return {
    columns: [
      { Header: "السمات", accessor: "attributes", align: "left" },
      { Header: "الكمية", accessor: "quantity", align: "center" },
      { Header: "سعر المنتج", accessor: "price", align: "center" },
      { Header: "سعر الشراء", accessor: "purchasePrice", align: "center" },
      { Header: "الصورة", accessor: "image", align: "center" },
      { Header: "الخصم", accessor: "discount", align: "center" },
      { Header: "الضريبة", accessor: "taxValue", align: "center" },
      { Header: "نوع الضريبة", accessor: "taxType", align: "center" },
      { Header: "الأبعاد (سم)", accessor: "dimensions", align: "center" },
      { Header: "الوزن (كجم)", accessor: "weight", align: "center" },
      { Header: "الحالة", accessor: "active", align: "center" },
      { Header: "SKU", accessor: "sku", align: "center" },
    ],
    rows: combinations.map((variant, index) => ({
      attributes: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {variant.combo.map((item, idx) => (
            <span key={idx}>
              {item.value} {/* هنا يجب أن تكون قيمة نصية وليس كائن */}
              {idx < variant.combo.length - 1 ? " | " : ""}
            </span>
          ))}
        </MDTypography>
      ),
      quantity: (
        <TextField
          label="الكمية"
          type="number"
          fullWidth
          value={variant.quantity || "0.0"}
          onChange={(e) => onPriceChange(index, "quantity", e.target.value)}
          onBlur={onQuantityBlur ? (e) => onQuantityBlur(index, e.target.value) : undefined}
          error={!!(quantityErrors && quantityErrors[index])}
          helperText={quantityErrors && quantityErrors[index] ? quantityErrors[index] : undefined}
        />
      ),
      price: (
        <TextField
          label="سعر المنتج"
          type="number"
          fullWidth
          value={variant.price}
          onChange={(e) => onPriceChange(index, "price", e.target.value)}
        />
      ),
      image: (
        <Box textAlign="center">
          {/* إدخال حقل رفع الصورة */}
          <input
            type="file"
            accept="image/*"
            hidden
            id={`upload-image-${index}`}
            onChange={(e) => handleImageChange(index, e)}
          />
          <label htmlFor={`upload-image-${index}`}>
            <IconButton component="span" color="primary" aria-label="رفع صورة">
              <UploadFile fontSize="small" />
            </IconButton>
          </label>

          {/* عرض الصورة (قديمة أو جديدة) */}
        </Box>
      ),
      purchasePrice: (
        <TextField
          label="سعر الشراء"
          type="number"
          fullWidth
          value={variant.purchasePrice || "0.0"}
          onChange={(e) => onPriceChange(index, "purchasePrice", e.target.value)}
        />
      ),
      discount: (
        <TextField
          label="الخصم"
          type="number"
          fullWidth
          value={variant.discount || "0.0"}
          onChange={(e) => onPriceChange(index, "discount", e.target.value)}
        />
      ),

      taxValue: (
        <TextField
          label="قيمة الضريبة"
          type="number"
          fullWidth
          value={variant.taxValue || "0.0"}
          onChange={(e) => onPriceChange(index, "taxValue", e.target.value)}
        />
      ),
      taxType: (
        <FormControl fullWidth size="small">
          <Select
            value={variant.taxType || "percentage"}
            onChange={(e) => onPriceChange(index, "taxType", e.target.value)}
          >
            <MenuItem value="percentage">نسبة مئوية</MenuItem>
            <MenuItem value="fixed">قيمة ثابتة</MenuItem>
          </Select>
        </FormControl>
      ),
      dimensions: (
        <Box display="flex" gap={1} justifyContent="center">
          <TextField
            label="الطول"
            type="number"
            size="small"
            value={variant.dimensions?.length || "0.0"}
            onChange={(e) =>
              onPriceChange(index, "dimensions", {
                ...variant.dimensions,
                length: e.target.value,
              })
            }
            sx={{ width: 80 }}
          />
          <TextField
            label="العرض"
            type="number"
            size="small"
            value={variant.dimensions?.width || "0.0"}
            onChange={(e) =>
              onPriceChange(index, "dimensions", {
                ...variant.dimensions,
                width: e.target.value,
              })
            }
            sx={{ width: 80 }}
          />
          <TextField
            label="العمق"
            type="number"
            size="small"
            value={variant.dimensions?.depth || "0.0"}
            onChange={(e) =>
              onPriceChange(index, "dimensions", {
                ...variant.dimensions,
                depth: e.target.value,
              })
            }
            sx={{ width: 80 }}
          />
        </Box>
      ),
      weight: (
        <TextField
          label="الوزن"
          type="number"
          fullWidth
          value={variant.weight || "0.0"}
          onChange={(e) => onPriceChange(index, "weight", e.target.value)}
        />
      ),
      active: (
        <MDTypography variant="caption" color={variant.active ? "success.main" : "error.main"}>
          {variant.active ? "نشط" : "غير نشط"}
        </MDTypography>
      ),
      sku: (
        <TextField
          label="sku"
          type="text"
          fullWidth
          value={variant.sku}
          onChange={(e) => onPriceChange(index, "price", e.target.value)}
        />
      ),
    })),
  };
}
